<mat-card>
   <mat-card-header>    
      <mat-card-title class="popupHeader">
        <div class="mat-card-header-text" i18n>
          Building Colors        
        </div>             
      </mat-card-title>  
     
      <button class="btnPalette" i18n-matTooltip matTooltip="Color picker" mat-icon-button [value]="colorPalette" [(colorPicker)]="colorPalette" 
      (colorPickerChange)="OnColorChange($event)">
        <mat-icon>color_lens</mat-icon>
      </button>          
  </mat-card-header>

  <mat-card-content>
     <mat-form-field class="my-form-field buildingFilterField">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="buildingFilter($event)">
      </mat-form-field>
    <div class="container">
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selectionModel.hasValue() && isAllSelected()"
                          [indeterminate]="selectionModel.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selectionModel.toggle(row) || add(row,$event) : null"
                          [checked]="selectionModel.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="clttxt">
          <th mat-header-cell *matHeaderCellDef i18n>ColorCode</th>
          <td mat-cell *matCellDef="let element">
            {{element.color}}
          </td>
        </ng-container>
        <ng-container matColumnDef="col">
          <th mat-header-cell *matHeaderCellDef i18n>Color</th>
          <td mat-cell *matCellDef="let element">
            <button class="colorBlock" [style.background-color]="element.color"></button>
          </td>
        </ng-container>       
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <div class="buttonContent">
      <button mat-raised-button type="button" color="primary" (click)="onSave()" i18n>SAVE</button>
    </div>    
  </mat-card-actions>
</mat-card>
